import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types';
import { COLUMN_WIDTH } from 'src/constants/ColumnWidth';
import { usePermission } from 'src/hooks';
import { useGenGridCol } from 'src/utils/ComponentHelper';
import { TableColumnKey } from '../types/Table';
import useApprovalProgressCell from './useApprovalProgressCell';
import useOperationsCell from './useOperationsCell';

const useTableColumns = () => {
  const { renderOperationsCell, renderApproveRejectDialog } = useOperationsCell();
  const { renderApprovalProgressCell, renderApprovalProgressDialog } = useApprovalProgressCell();

  const { hasPermission } = usePermission();

  const hasApprovePermission = hasPermission(
    AgentPortalFeatureCode.DistributorAgentManagement.CreditAllocation.Approve.prefix
  );
  const hasRejectPermission = hasPermission(
    AgentPortalFeatureCode.DistributorAgentManagement.CreditAllocation.Reject
  );

  const columns = [
    useGenGridCol('operation', {
      renderCell: (param) => renderOperationsCell(param),
      hide: !hasApprovePermission && !hasRejectPermission,
      minWidth: 150,
    }),
    useGenGridCol(TableColumnKey.OrderId),
    useGenGridCol(TableColumnKey.ApprovalProgress, {
      minWidth: COLUMN_WIDTH.ApprovalProgress.MinWidth,
      renderCell: renderApprovalProgressCell,
    }),
    useGenGridCol(TableColumnKey.PfhNo, { minWidth: 150 }),
    useGenGridCol(TableColumnKey.CreditCurrency),
    useGenGridCol(TableColumnKey.CreditAmount, { minWidth: 150 }),
    useGenGridCol(TableColumnKey.Status),
    useGenGridCol(TableColumnKey.CreatedBy),
    useGenGridCol(TableColumnKey.CreationTime, { minWidth: 150 }),
    useGenGridCol(TableColumnKey.LastModifiedTime, { minWidth: 150 }),
  ];
  return { columns, renderApproveRejectDialog, renderApprovalProgressDialog };
};

export default useTableColumns;
